import Loading from '../../../Common/Loading';
import { useOcurrencesChartsDataContext } from './hooks/useOcurrencesChartsDataContext';
import './styles/Charts.css';
import { TotalOcurrences } from './TotalOcurrences';
import { AnualOcurrencesEvolution } from './AnualOcurrencesEvolution';
import { HomeAndTerritorialVisits } from './HomeAndTerritorialVisits';
import { OcurrenceByForwarding } from './OcurrenceByForwarding';
import { OcurrencesByCallLocation } from './OcurrencesByCallLocation';

export const Charts = () => {
    const { isLoading } = useOcurrencesChartsDataContext();

    if (isLoading) {
        return <Loading />;
    }

    return (
        <>
            <div className="charts-side-by-side-dashboards align-items-stretch ">
                <TotalOcurrences />
                <HomeAndTerritorialVisits />
            </div>
            <div className="chats-indicators-side-by-side-dashboards">
                <AnualOcurrencesEvolution />
                <OcurrenceByForwarding />
            </div>
            <OcurrencesByCallLocation />
        </>
    );
};
